import { render, staticRenderFns } from "./contentPricingDelete.vue?vue&type=template&id=8ccb9736&"
import script from "./contentPricingDelete.vue?vue&type=script&lang=js&"
export * from "./contentPricingDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports